import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { http } from "@/api";
import ProductCard from "@/components/ProductCard";

export default function Catalog() {
  const { category, subcategory } = useParams();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    http.get("/categories").then((r) => setCategories(r.data));
  }, []);

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (category) params.category = category;
    if (subcategory) params.subcategory = subcategory;
    http.get("/products", { params }).then((r) => {
      setProducts(r.data);
      setLoading(false);
    });
  }, [category, subcategory]);

  const currentCat = categories.find((c) => c.slug === category);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="catalog-page">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-8">
        <div>
          <div className="text-xs uppercase tracking-widest text-[var(--brand-accent)] font-bold">Catálogo</div>
          <h1 className="font-serif text-4xl sm:text-5xl font-bold mt-2">
            {currentCat?.name || "Todos los productos"}
          </h1>
          {subcategory && (
            <div className="text-neutral-500 mt-2">
              {currentCat?.subcategories?.find((s) => s.slug === subcategory)?.name}
            </div>
          )}
        </div>
      </div>

      <div className="flex flex-wrap gap-2 mb-8">
        <Link
          to="/catalogo"
          className={`px-4 py-2 rounded-full text-sm font-semibold border transition ${
            !category ? "bg-[var(--brand-primary)] text-white border-transparent" : "bg-white border-black/10 hover:border-[var(--brand-primary)]"
          }`}
          data-testid="filter-all"
        >
          Todas
        </Link>
        {categories.map((c) => (
          <Link
            key={c.slug}
            to={`/catalogo/${c.slug}`}
            className={`px-4 py-2 rounded-full text-sm font-semibold border transition ${
              category === c.slug && !subcategory
                ? "bg-[var(--brand-primary)] text-white border-transparent"
                : "bg-white border-black/10 hover:border-[var(--brand-primary)]"
            }`}
            data-testid={`filter-${c.slug}`}
          >
            {c.name}
          </Link>
        ))}
      </div>

      {currentCat?.subcategories?.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-8">
          {currentCat.subcategories.map((s) => (
            <Link
              key={s.slug}
              to={`/catalogo/${category}/${s.slug}`}
              className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition ${
                subcategory === s.slug
                  ? "bg-[var(--brand-accent)] text-white border-transparent"
                  : "bg-white border-black/10 hover:border-[var(--brand-accent)]"
              }`}
              data-testid={`subfilter-${s.slug}`}
            >
              {s.name}
            </Link>
          ))}
        </div>
      )}

      {category === "arreglos" && (
        <div className="mb-8 p-4 rounded-xl bg-[var(--brand-accent)]/10 border border-[var(--brand-accent)]/20 text-sm text-[var(--brand-accent)] font-medium">
          Importante: estos arreglos los realizamos en la tonalidad que nos indiques.
        </div>
      )}

      {loading ? (
        <div className="text-center py-20 text-neutral-500">Cargando...</div>
      ) : products.length === 0 ? (
        <div className="text-center py-20 text-neutral-500">
          <p className="font-serif text-2xl">Sin productos en esta categoría</p>
          <p className="text-sm mt-2">Pronto agregaremos nuevos modelos.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {products.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
